(function(){
var ROOT=document.querySelector('.pw');
if(!ROOT||ROOT.getAttribute('data-pwfv'))return;
ROOT.setAttribute('data-pwfv','3');
var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

/* The world frame must never scroll inside itself. Something taller than
   the world (the bag's discount slip waits below it) let the browser
   scroll the frame and show its dark backing instead of the drawing. */
ROOT.addEventListener('scroll',function(){if(ROOT.scrollTop||ROOT.scrollLeft){ROOT.scrollTop=0;ROOT.scrollLeft=0}});

/* Phone: a vertical swipe pans the world like a sideways one. Only for a
   finger that lands on bare world - never the newspaper, a window, the
   bag (it claims its own touch) or the discount slip. */
var t=null;
function bare(el){
  var vp=ROOT.querySelector('.pw__viewport');
  if(!vp||!el||!el.closest||!vp.contains(el))return false;
  return !el.closest('.pw-win, .pw-mini, .pw__hint, .pw__full, .pr, .pwr-bag, .pwr-card, input, textarea, select, a');
}
window.addEventListener('pointerdown',function(e){
  t=null;
  if(!e.isTrusted||e.pointerType!=='touch'||e.defaultPrevented||!bare(e.target))return;
  t={x:e.clientX,y:e.clientY,id:e.pointerId};
});
window.addEventListener('pointermove',function(e){
  if(!t||!e.isTrusted||e.pointerId!==t.id)return;
  e.stopImmediatePropagation();
  window.dispatchEvent(new PointerEvent('pointermove',{clientX:e.clientX+(e.clientY-t.y),clientY:t.y,pointerId:e.pointerId,pointerType:'touch',isPrimary:true,bubbles:true}));
},true);
function clear(e){if(t&&e.pointerId===t.id)t=null}
window.addEventListener('pointerup',clear,true);
window.addEventListener('pointercancel',clear,true);

/* The newspaper listens for a click on its object, but the world grabs the
   pointer on every press (that is what keeps dragging smooth), so the
   browser hands the click to the world frame and the paper never hears
   it. A clean tap on the newspaper object is passed on to the paper. */
var tap=null;
function paperObj(el){
  var o=el&&el.closest&&el.closest('.pw__object');if(!o)return null;
  var pr=document.getElementById('parade-riots');
  var keys=((pr&&pr.dataset.objects)||'').toLowerCase().split(',');
  var k=(o.dataset.opens||o.getAttribute('data-window')||o.getAttribute('aria-label')||'').toLowerCase();
  return (k&&(keys.indexOf(k)>-1||/riot|news|dispatch/.test(k)))?o:null;
}
document.addEventListener('pointerdown',function(e){
  var o=paperObj(e.target);
  tap=o?{o:o,x:e.clientX,y:e.clientY,t:Date.now()}:null;
},true);
document.addEventListener('pointerup',function(e){
  var d=tap;tap=null;
  if(!d||!window.paradeRiots||!e.isTrusted)return;
  if(d.o.contains(e.target))return; /* not grabbed: the paper hears its own click */
  if(Math.hypot(e.clientX-d.x,e.clientY-d.y)>8||Date.now()-d.t>700)return; /* that was a drag */
  window.paradeRiots.toggle();
},true);

function init(){
var vp=ROOT.querySelector('.pw__viewport'),sc=ROOT.querySelector('.pw__scene');
if(!vp||!sc)return;
if(getComputedStyle(ROOT).position==='static')ROOT.style.position='relative';
var stopped=false,raf=null,timers=[];
function later(f,ms){timers.push(setTimeout(f,ms))}
function curX(){var m=/translate3d\(\s*(-?[\d.]+)px/.exec(sc.style.transform||'');return m?parseFloat(m[1]):0}
function minX(){return Math.min(0,vp.clientWidth-sc.offsetWidth)}

/* Move the world through its own wheel handler, so it always knows where
   it is - a touch in the middle of the arrival never makes it jump. */
function shove(dx){if(dx)vp.dispatchEvent(new WheelEvent('wheel',{deltaY:dx,deltaX:0,deltaMode:0,bubbles:true,cancelable:true}))}
function ease(p){return p<.5?4*p*p*p:1-Math.pow(-2*p+2,3)/2}
function tween(to,ms,done){
  var from=curX(),t0=performance.now();
  if(raf)cancelAnimationFrame(raf);
  (function step(now){
    if(stopped)return;
    var p=Math.min(1,(now-t0)/ms),want=from+(to-from)*ease(p);
    shove(curX()-want);
    if(p<1)raf=requestAnimationFrame(step);else{raf=null;if(done)done()}
  })(t0);
}

/* the record on the turntable actually turns */
var rec=ROOT.querySelector('.pw__object[data-opens="record"]');
/* the iPod needs no spinning record (removed Oct 7 2026) */

/* position line: dark = everything seen so far, red = where you are now */
var line=document.createElement('div');line.className='pwfv-line';line.setAttribute('role','progressbar');line.setAttribute('aria-label','How much of the world you have seen');line.setAttribute('aria-valuemin','0');line.setAttribute('aria-valuemax','100');
var seenEl=document.createElement('i'),nowEl=document.createElement('i');seenEl.className='pwfv-seen';nowEl.className='pwfv-now';line.appendChild(seenEl);line.appendChild(nowEl);
/* it lives in the footer band, not on the drawing */
(document.querySelector('.pr-foot')||ROOT).appendChild(line);
var A=null,B=null;
/* Oct 29 2026: the line now moves by transform only, and measures the world once (and again on resize), not on every frame of a swipe.
   Before, each frame of a swipe it measured the page and changed left/width, which made the phone re-lay out the page every frame - part of the swipe lag. */
var LW=0,LS=0,nowW='',lastV=-1;
function measure(){LW=vp.clientWidth;LS=sc.offsetWidth||0}
seenEl.style.left='0';seenEl.style.width='100%';seenEl.style.transformOrigin='0 50%';seenEl.style.willChange='transform';
nowEl.style.left='0';nowEl.style.willChange='transform';
function draw(){if(!LW||!LS)measure();var W=LW,S=LS||1,a=-curX(),b=a+W;
  if(A===null||a<A)A=a;if(B===null||b>B)B=b;
  seenEl.style.transform='translateX('+(A/S*100).toFixed(3)+'%) scaleX('+((B-A)/S).toFixed(5)+')';
  var w=(W/S*100).toFixed(3)+'%';if(w!==nowW){nowW=w;nowEl.style.width=w}
  nowEl.style.transform='translateX('+(W?a/W*100:0).toFixed(3)+'%)';
  var v=Math.round((B-A)/S*100);if(v!==lastV){lastV=v;line.setAttribute('aria-valuenow',v)}}
new MutationObserver(draw).observe(sc,{attributes:true,attributeFilter:['style']});
addEventListener('resize',function(){A=B=null;measure();draw()});
addEventListener('load',function(){measure();draw()});
draw();setTimeout(function(){measure();draw();line.classList.add('on')},600);

/* the ghost hand */
var hand=document.createElement('div');hand.className='pwfv-hand';hand.setAttribute('aria-hidden','true');
var NS='http://www.w3.org/2000/svg',svg=document.createElementNS(NS,'svg'),path=document.createElementNS(NS,'path');
svg.setAttribute('viewBox','0 0 48 56');
path.setAttribute('d','M18 30V10a4 4 0 0 1 8 0v16l11 3c3 1 4 3 4 6l-2 14c-.4 3-2 5-5 5H21c-3 0-5-1.5-6.5-4L7 37c-1-2 0-4 2-4s3 .8 4 2l5 6z');
path.setAttribute('fill','rgba(239,234,219,.62)');path.setAttribute('stroke','#17150F');path.setAttribute('stroke-opacity','.7');path.setAttribute('stroke-width','1.6');path.setAttribute('stroke-linejoin','round');
svg.appendChild(path);hand.appendChild(svg);ROOT.appendChild(hand);
var anim=null;

function stopAll(){
  if(stopped)return;stopped=true;
  timers.forEach(clearTimeout);timers=[];
  if(raf){cancelAnimationFrame(raf);raf=null}
  if(anim){anim.cancel();anim=null}
  hand.classList.remove('on');
}
vp.addEventListener('pointerdown',function(e){if(e.isTrusted)stopAll()},true);
vp.addEventListener('wheel',function(e){if(e.isTrusted)stopAll()},{passive:true,capture:true});
addEventListener('keydown',function(e){if(e.isTrusted&&(e.key==='ArrowLeft'||e.key==='ArrowRight'))stopAll()});

/* the one obvious object: whatever sits nearest the middle where the site lands */
function nudge(){
  if(stopped)return;
  var r0=vp.getBoundingClientRect(),mid=r0.left+r0.width/2,best=null,bd=1e9;
  [].forEach.call(ROOT.querySelectorAll('.pw__object'),function(b){var r=b.getBoundingClientRect();
    if(!r.width||r.width>r0.width*.4||r.right<r0.left||r.left>r0.right)return;
    var d=Math.abs(r.left+r.width/2-mid);if(d<bd){bd=d;best=b}});
  if(best&&window.pwGlint)window.pwGlint(best)
}

/* Arrival, on every load: the hand IS the arrival. It lands in the middle,
   presses, drags the world one way, then all the way the other, lets go,
   and the world settles back where the site lands. Any touch, drag, wheel
   or arrow key from the visitor stops it on the spot. */
function arrive(){
  if(stopped)return;
  if(RM){nudge();return}
  var x0=curX(),W=vp.clientWidth,H=vp.clientHeight,reach=Math.round(Math.min(200,Math.max(80,W*.24)));
  var dl=x0-Math.max(minX(),x0-reach),dr=Math.min(0,x0+reach)-x0;
  if(dl<8&&dr<8){nudge();return}
  var T=5000,o=function(ms){return ms/T};
  hand.style.left=(W*.5)+'px';hand.style.top=(H*.6)+'px';hand.classList.add('on');
  anim=hand.animate([
    {opacity:0,transform:'translate(0,12px) scale(.92)',offset:0},
    {opacity:.72,transform:'translate(0,0) scale(1)',offset:o(450)},
    {opacity:.72,transform:'translate(0,0) scale(.9)',offset:o(700)},
    {opacity:.72,transform:'translate('+(-dl)+'px,0) scale(.9)',offset:o(2000)},
    {opacity:.72,transform:'translate('+(-dl)+'px,0) scale(.9)',offset:o(2200)},
    {opacity:.72,transform:'translate('+dr+'px,0) scale(.9)',offset:o(4300)},
    {opacity:0,transform:'translate('+dr+'px,-8px) scale(1)',offset:o(4800)},
    {opacity:0,transform:'translate('+dr+'px,-8px) scale(1)',offset:1}
  ],{duration:T,easing:'linear',fill:'forwards'});
  later(function(){tween(x0-dl,1300,function(){
    later(function(){tween(x0+dr,2100,function(){
      later(function(){tween(x0,1300,function(){hand.classList.remove('on');anim=null;later(nudge,300)})},250);
    })},200);
  })},700);
}
/* Oct 23 2026: the ghost hand and its arrival pan are removed - the sunrise is the arrival now */
}
if(document.readyState==='complete')setTimeout(init,700);else addEventListener('load',function(){setTimeout(init,700)});
})();
